import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AgencyService } from 'app/_services';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class OthersGuardGuard implements CanActivate {

  constructor(
    private agencyService: AgencyService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.agencyService.getOthersPermissions().pipe(
      map(response => {
        // ✅ Allow access if either is true
        if (response?.payroll || response?.view_work_validation) {
          return true;
        }

        // ❌ Otherwise, redirect to a fallback page (like /dashboard or /)
        return this.router.createUrlTree(['/projects']);
      }),
      catchError(() => {
        // In case of an API error, block access and redirect
        return of(this.router.createUrlTree(['/projects']));
      })
    );
  }
}
